// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"496":"a42052d7","936":"a42052d7","1984":"a42052d7","3491":"a42052d7"}[chunkId] + ".chunk.css";
};